export default __webpack_public_path__ + "static/media/Banner.84efa0fa.png";